import React from 'react';
import { CRow, CCol, CSpinner, CAlert } from '@coreui/react';
import ChartCard from '../components/ChartCard';
import { getAreaChartOptions, getBarChartOptions, CHART_COLORS } from '../utils/chartConfig';

/**
 * RealtimeView component displays real-time analytics data.
 */
const RealtimeView = ({ isLoading, error, data }) => {

  return (
    <>
      <div className="mb-4">
        <h3 className="text-primary mb-3">Real-time Analytics</h3>
        <p className="text-muted">Data from the last 3 days</p>
      </div>

      {isLoading && (
        <div className="text-center py-5">
          <CSpinner color="primary" />
        </div>
      )}

      {error && (
        <CAlert color="danger">
          {error}
        </CAlert>
      )}

      {!isLoading && !error && (
        <CRow>
          <CCol md={6}>
            <ChartCard
              title="Device Registrations"
              data={data.registerNumByHour}
              chartType="AreaChart"
              options={getAreaChartOptions()}
            />
          </CCol>
          <CCol md={6}>
            <ChartCard
              title="Device Registrations by Country"
              data={data.registerNumByCountry}
              chartType="BarChart"
              options={getBarChartOptions()}
            />
          </CCol>
          <CCol md={6}>
            <ChartCard
              title="Usage Metrics"
              data={data.usageByHour}
              chartType="AreaChart"
              options={getAreaChartOptions()}
            />
          </CCol>
          <CCol md={6}>
            <ChartCard
              title="Usage by Country"
              data={data.usageByCountry}
              chartType="BarChart"
              options={getBarChartOptions()}
            />
          </CCol>
        </CRow>
      )}
    </>
  );
};

export default RealtimeView;